import { EuiButton, EuiEmptyPrompt, Pagination } from "@elastic/eui";
import {
  Badge,
  Box,
  Button,
  Checkbox,
  CopyButton,
  Flex,
  Grid,
  Group,
  LoadingOverlay,
  Text,
  Tooltip,
} from "@mantine/core";
import { useDisclosure } from "@mantine/hooks";
import {
  IconCategoryMinus,
  IconCheck,
  IconEyeSearch,
  IconSortAscendingLetters,
  IconX,
} from "@tabler/icons-react";
import React, { ReactNode, useEffect, useRef, useState } from "react";
import { NotificationExtension } from "../../../../_base/extension/NotificationExtension";
import {
  isNullOrEmpty,
  isNullOrUndefined,
  isNullOrUndefinedArry,
} from "../../../../_base/extension/StringExtension";
import { paginationBase } from "../../../../_base/model/_base/BaseTable";
import { getListAttributeIDS } from "../../../../api/ApiAttribute";
import { handleEditCategoryAttrNew } from "../../../../api/ApiProduct";
import ButtonClose from "../../../../common/ButtonClose/ButtonClose";
import OpenProductTab from "../../../../components/ProductTabs";
import { TblItemCategoryAttrModel } from "../../../../model/ProductList";
import { TblAttributeModel } from "../../../../model/TblAttributeModelFix";
import { TblAttributeValueModel } from "../../../../model/TblAttributeValueModel";
import { useProductCreateStore } from "../../../../store/useProductCreateStore";
import { useNavigate } from "react-router-dom";

const ItemCategoryAttrModels = () => {
  const navigate = useNavigate();
  const { dataItemCategoryAttrModel, setDataItemCategoryAttrModel } =
    useProductCreateStore();
  const dataItemBase = useProductCreateStore((state) => state.dataItemBase);
  const { dataItemCategory, setDataItemCategory } = useProductCreateStore(); //danh mục mà sản phẩm đang thuộc về
  const hacomUrl = process.env.REACT_APP_BASE_WEB_HACOM_URL;
  const [toltal, setTotal] = useState(0);
  const [error, setError] = useState<string | undefined>();
  const [pagination, setPagination] = useState<Pagination>(paginationBase);
  const [sortAscendingLetters, setSortAscendingLetters] =
    useState<boolean>(true);
  const [message, setMessage] = useState<ReactNode>(
    <EuiEmptyPrompt
      title={<h3>Dữ liệu rỗng !</h3>}
      titleSize="xs"
      body="Tải lại dữ liệu nếu trường hợp bạn không thấy có dữ liệu hiển thị !"
      actions={
        <EuiButton
          size="s"
          key="loadUsers"
          onClick={async () => {
            await loadDataAttribute(pagination.pageIndex, pagination.pageSize);
          }}
        >
          Tải dữ liệu !
        </EuiButton>
      }
    />
  );
  const [visible, { open, close, toggle }] = useDisclosure(false);

  const [listItemCategoryAttr, setListItemCategoryAttr] = useState<
    TblAttributeModel[]
  >([]);

  const initialDataItemCategoryAttrModel = useRef<TblItemCategoryAttrModel[]>(
    []
  ); // dùng để lưu giá trị ban đầu của data
  // console.log("dataItemBase", dataItemBase);
  // console.log("dataItemCategorydsdsds", dataItemCategory);
  const loadDataAttribute = async (
    index: number,
    size?: number,
    keyWord?: string,
    inActive?: boolean
  ) => {
    open();
    setMessage("Đang lấy dữ liệu...");
    setListItemCategoryAttr([]);
    setError(undefined); //get-list?KeySearch=1&Active=true&Skip=1&Take=1

    try {
      // let urlSearch = `?Skip=${index * (size ?? 0)}&Take=1000`;
      let urlSearch = `?Skip=${index * (size ?? 0)}&Take=1000`;
      if (!isNullOrEmpty(keyWord))
        urlSearch = urlSearch + `&KeySearch=` + keyWord;
      if (!isNullOrUndefined(inActive))
        urlSearch = urlSearch + `&Active=` + inActive;

      // Thêm CategoryId từ dataItemCategory nếu có dữ liệu
      if (dataItemCategory && dataItemCategory.length > 0) {
        const categoryParams = dataItemCategory
          .map((category) => `CategoryId=${category.categoryId}`)
          .join("&");
        urlSearch = urlSearch + `&` + categoryParams;
      }

      // let callapi = await getAllAttribute(urlSearch);
      let callapi = await getListAttributeIDS(urlSearch);
      // console.log("callapi", callapi);
      if (isNullOrUndefined(callapi) || isNullOrUndefinedArry(callapi?.data)) {
        setTotal(0);
      } else {
        setListItemCategoryAttr(callapi?.data ?? []);
        setPagination({
          ...pagination,
          totalItemCount: callapi?.totalCount ?? 0,
        });
        setTotal(callapi?.totalCount ?? 0);
      }
      return callapi?.data;
    } catch (error: any) {
      setError("Có lỗi xảy ra khi tải dữ liệu !");
      return null;
    } finally {
      close();
    }
  };

  useEffect(() => {
    if (dataItemCategory && dataItemCategory.length > 0) {
      loadDataAttribute(pagination.pageIndex, pagination.pageSize);
    }
  }, [pagination.pageIndex, pagination.pageSize, dataItemCategory]);

  const handleCheckBoxChange = async (
    valueIds: string,
    item: TblAttributeValueModel
  ) => {
    // console.log("dataItemCategoryAttrModel", dataItemCategoryAttrModel);

    // console.log("valueIds", valueIds);
    // console.log("item", item);
    const isValueInDataOptionAttribute = dataItemCategoryAttrModel.some(
      (item) => String(item.attributeValueId) === String(valueIds)
    );
    // console.log("isValueInDataOptionAttribute", isValueInDataOptionAttribute);
    // Nếu giá trị không có trong dataOptionAttribute, thêm nó vào
    if (!isValueInDataOptionAttribute) {
      setDataItemCategoryAttrModel([
        ...dataItemCategoryAttrModel,
        {
          // id: item?.id || 0, // ID mới sẽ được tạo khi lưu
          id: 0, // ID mới sẽ được tạo khi lưu
          itemId: dataItemBase?.id || 0, // ID của sản phẩm
          categoryId: 0,
          attributeId: item?.attributeId,
          attributeValueId: item?.id,
          value: item?.value,
          status: "Y",
          orderNumber: item?.orderNumber,
          creationDate: item?.creationDate || null,
          createdBy: item?.createdBy || null, // Người tạo
          lastUpdateDate: item?.lastUpdateDate || null,
          lastUpdatedBy: item?.lastUpdatedBy || null,
          lastUpdatedLogin: item?.lastUpdatedLogin || null,
        } as TblItemCategoryAttrModel,
      ]);
    } else {
      // Nếu giá trị đã có trong dataItemCategoryAttrModel, xoá nó đi
      const dataFilter = dataItemCategoryAttrModel.filter(
        (item) => String(item.attributeValueId) !== String(valueIds)
      );
      setDataItemCategoryAttrModel(dataFilter);
    }
  };
  // console.log("dataItemCategoryAttrModel2", dataItemCategoryAttrModel);

  // console.log("listItemCategoryAttr2", listItemCategoryAttr);

  const handleSubmitForm = async () => {
    try {
      open();
      const payload = (dataItemCategoryAttrModel || []).filter(
        (item) =>
          Number(item.attributeId ?? 0) !== 0 &&
          Number(item.attributeValueId ?? 0) !== 0
      );
      const response = await handleEditCategoryAttrNew(payload);
      // console.log("response", response);
      if (response && response.success) {
        NotificationExtension.Success(
          "Cập nhật thuộc tính sản phẩm thành công"
        );
      }
    } catch (error) {
      console.log("error", error);
    } finally {
      close();
    }
  };
  const onNavigateOnWeb = () => {
    window.open(`${hacomUrl}/${dataItemBase?.url}`, "_blank");
  };
  return (
    <>
      <Box
        className="flex-none"
        mx="10px"
        style={{ position: "relative", minHeight: 500 }}
      >
        <LoadingOverlay
          visible={visible}
          zIndex={1000}
          overlayProps={{ radius: "sm", blur: 2 }}
        />

        <Flex justify={"space-between"} align={"center"} my={10}>
          <CopyButton value={String(dataItemBase?.itemName)} timeout={2000}>
            {({ copied, copy }) => (
              <Tooltip
                label={copied ? "Đã sao chép" : "Sao chép"}
                withArrow
                position="right"
              >
                <Badge
                  color={copied ? "teal" : "blue"}
                  onClick={copy}
                  style={{ cursor: "pointer" }}
                  size="lg"
                >
                  {dataItemBase?.itemName}
                </Badge>
              </Tooltip>
            )}
          </CopyButton>
          <Button
            leftSection={
              !sortAscendingLetters ? (
                <IconSortAscendingLetters size={16} />
              ) : (
                <IconCategoryMinus size={16} />
              )
            }
            color={!sortAscendingLetters ? "green" : "blue"}
            onClick={() => setSortAscendingLetters(!sortAscendingLetters)}
          >
            {!sortAscendingLetters
              ? "Sắp xếp theo kí tự A đến Z"
              : "Sắp xếp theo STT của thuộc tính"}
          </Button>
        </Flex>

        <Box>
          {listItemCategoryAttr.map((item, index) => (
            <Grid
              key={index}
              mt="xs"
              pb="sm"
              display={"flex"}
              ml={"md"}
              style={{ borderBottom: "1px solid lightgray" }}
            >
              <Grid.Col span={{ base: 12, xs: 2 }}>
                <Text fw={700} size="lg">
                  {item.attributeName}
                </Text>
                <Text fw={350}>{item.attributeCode}</Text>
                <Text fw={350} color="red">
                  Dùng là bộ lọc
                </Text>
                <Text fw={350} color="red">
                  Hiển thị ở tóm tắt
                </Text>
              </Grid.Col>

              <Grid.Col span={{ base: 12, xs: 10 }}>
                {(() => {
                  const chunkedData = [];
                  const col =
                    item.tblAttributeValueModels &&
                    Array.isArray(item.tblAttributeValueModels)
                      ? Math.floor(
                          Number(item.tblAttributeValueModels.length) / 6
                        )
                      : 0;
                  const residual =
                    item.tblAttributeValueModels &&
                    Array.isArray(item.tblAttributeValueModels)
                      ? Number(item.tblAttributeValueModels.length) % 6
                      : 0;
                  const colRender = residual > 0 ? col + 1 : col;
                  if (item.tblAttributeValueModels && !sortAscendingLetters) {
                    for (
                      let i = 0;
                      i < item.tblAttributeValueModels.length;
                      i += colRender
                    ) {
                      chunkedData.push(
                        item.tblAttributeValueModels.slice(i, i + colRender)
                      );
                    }
                  } else if (
                    item.tblAttributeValueModels &&
                    sortAscendingLetters
                  ) {
                    const dataSort = [...item.tblAttributeValueModels].sort(
                      (a, b) => (a.value || "").localeCompare(b.value || "")
                    );

                    for (let i = 0; i < dataSort.length; i += colRender) {
                      chunkedData.push(dataSort.slice(i, i + colRender));
                    }
                  }

                  return (
                    <Grid>
                      {chunkedData.map((dataChunk, columnIndex) => (
                        <Grid.Col
                          span={{
                            base: 12,
                            md: 6,
                            lg:
                              String(item.attributeCode)?.trim() ===
                              "may_tinh_de_ban_theo_nhu_cau"
                                ? 3
                                : 2,
                          }}
                          key={columnIndex}
                        >
                          {dataChunk.map((option) => (
                            <Checkbox
                              key={option.id}
                              // label={option.value}
                              label={
                                <Text
                                  dangerouslySetInnerHTML={{
                                    __html: option.value || "",
                                  }}
                                />
                              }
                              checked={dataItemCategoryAttrModel.some(
                                (attr) =>
                                  String(attr.attributeValueId) ===
                                  String(option.id)
                              )}
                              value={String(option.id)}
                              onChange={(event) =>
                                handleCheckBoxChange(
                                  event.currentTarget.value,
                                  option
                                )
                              }
                              // {...form.getInputProps(`${option.id}`)}
                            />
                          ))}
                        </Grid.Col>
                      ))}
                    </Grid>
                  );
                })()}
              </Grid.Col>
            </Grid>
          ))}
        </Box>

        <Group
          justify="flex-end"
          mt="lg"
          p="10px 0"
          bg={"rgba(255, 255, 255, 0)"}
          style={{
            position: "sticky",
            bottom: 10,
            margin: "0px 75px",
            zIndex: "1000",
          }}
        >
          <Button
            type="button"
            color="#3598dc"
            leftSection={<IconEyeSearch size={18} />}
            onClick={() => onNavigateOnWeb()}
            variant="filled"
          >
            Xem trên web
          </Button>
          <OpenProductTab
            productId={dataItemBase?.id}
            itemCode={dataItemBase?.itemName ?? ""}
            tabToOpen="info5"
            buttonText="Mở trang tab"
            variant="filled"
          />
          <Button
            type="button"
            color="#3598dc"
            onClick={() => {
              handleSubmitForm();
            }}
            leftSection={<IconCheck size={18} />}
            variant="filled"
          >
            Lưu
          </Button>
          <Button
            color="red"
            onClick={() => {
              navigate(-1);
            }}
            leftSection={<IconX size={18} />}
            variant="filled"
          >
            Đóng
          </Button>
        </Group>
      </Box>
    </>
  );
};

export default React.memo(ItemCategoryAttrModels);
